import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CrudImplementation} from '@shared/services/crud-implementation';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CrudNewsService extends CrudImplementation {
  protected url = '/v1/admin/news';

  updateEntity(id: string, entity: {}): Observable<any> {
    entity = this.adjustDateTime(entity);
    return super.updateEntity(id, entity);
  }

  createEntity(entity: {}): Observable<any> {
    entity = this.adjustDateTime(entity);
    return super.createEntity(entity);
  }

  /**
   * TODO
   * use tool crud
   */
  getToolsList(): Observable<any> {
    const url = '/v1/admin/dropdown/tools';
    return this.http.get(this.serverRoot + url);
  } // getClientList

  /**
   * TODO
   * use other crud???
   */
  getNewTypeList(): Observable<any> {
    const url = '/v1/admin/dropdown/newtype';
    return this.http.get(this.serverRoot + url);
  } // getNewTypeList


  private adjustDateTime(entity: any) {
    if (entity.eventDatekey) {
      entity.eventDatekey = moment(entity.eventDatekey, 'DD.MM.YYYY').format('YYYY-MM-DD');
      entity.eventDatekey = entity.eventDatekey + ' 00:00:00';
    }
    if (entity.validTokey) {
      entity.validTokey = moment(entity.validTokey, 'DD.MM.YYYY').format('YYYY-MM-DD');
      entity.validTokey = entity.validTokey + ' 23:59:59';
    }
    if (entity.validFromkey) {
      entity.validFromkey = moment(entity.validFromkey, 'DD.MM.YYYY').format('YYYY-MM-DD');
      entity.validFromkey = entity.validFromkey + ' 00:00:00';
    }
    return entity;
  }
}
